import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ListOrdered = createReactComponent("ListOrdered", ["svg", defaultAttributes, [["line", {
  x1: "10",
  y1: "6",
  x2: "21",
  y2: "6",
  key: "g3fxpu"
}], ["line", {
  x1: "10",
  y1: "12",
  x2: "21",
  y2: "12",
  key: "dmx5v6"
}], ["line", {
  x1: "10",
  y1: "18",
  x2: "21",
  y2: "18",
  key: "c5zasy"
}], ["path", {
  d: "M4 6h1v4",
  key: "r283p1"
}], ["path", {
  d: "M4 10h2",
  key: "1ioyz2"
}], ["path", {
  d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1",
  key: "plto16"
}]]]);
export default ListOrdered;